// Define globally exposed module objects
/* eslint-disable */
// Define dependency imports
// Define local components
import 'bootstrap';
import 'readmore-js';
import popovers from './components/popovers';
import tooltips from './components/tooltips';
import navigation from './components/navigation';
import content from './components/content';
import sitemap from './components/sitemap';
import search from './components/search';
import form from './components/form';
import matchHeight from './components/match-height';
import backToTop from './components/back-to-top';
import ajaxNavbarMobile from './components/ajax-navbar-mobile';
import img from './components/img';
import gtm from './components/gtm';
import gallery from './components/gallery';
ajaxNavbarMobile();
popovers();
tooltips();
matchHeight();
backToTop();
navigation();
content();
sitemap();
search();
form();
img();
gtm();
gallery();
/* eslint-enable */
